export default __webpack_public_path__ + "static/media/ico_info.58e2e23b.svg";